// Render the single-page UI by mutating the static DOM.

import { FACES, MESSAGES } from './constants.js'
import type { Mode } from './constants.js'

let currentMode: Mode | undefined

/*
 * Show the given mode; no-op when it is already shown.
 */
export const renderMode = (mode: Mode) => {
  if (mode === currentMode) {
    return
  }
  currentMode = mode

  const main = document.querySelector('main')
  const face = document.querySelector('#face-text')
  const subtitle = document.querySelector('#subtitle-text')

  if (!main || !face || !subtitle) {
    return
  }

  main.setAttribute('data-mode', mode)
  face.textContent = FACES[mode]
  subtitle.textContent = MESSAGES[mode]
}
